import { ModelBase } from 'store/model-base';

export class NowLineLock extends ModelBase {
    public static storeName: string = 'nowLineLock';

    public mdnLockEnabled: boolean;
    public mdn: string;
    public lockReasonCode: string;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowLineLock = super.create<NowLineLock>(initData);

        return super.create<T>(toReturn);
    }
}
